/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_PlayersInputs */

const th_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้เล่น`)
};

const en_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Players`)
};

const ja_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選手`)
};

const zh_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球员`)
};

const es_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jugadores`)
};

const pt_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogadores`)
};

const id_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain`)
};

const fr_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joueurs`)
};

const tl_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga manlalaro`)
};

const vi_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cầu thủ`)
};

const ko_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`선수`)
};

const de_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spieler`)
};

const ru_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Игроки`)
};

const tr_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyuncular`)
};

const it_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giocatori`)
};

const pl_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zawodnicy`)
};

const uk_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гравці`)
};

const hi_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खिलाड़ी`)
};

const ar_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللاعبون`)
};

const ms_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain`)
};

const bn_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলোয়াড়`)
};

const zh_tw2_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球員`)
};

const zh_hk2_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球員`)
};

const ur_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کھلاڑی`)
};

const fa_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بازیکنان`)
};

const sw_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachezaji`)
};

const nl_tab_players = /** @type {(inputs: Tab_PlayersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelers`)
};

/**
* | output |
* | --- |
* | "Players" |
*
* @param {Tab_PlayersInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_players = /** @type {((inputs?: Tab_PlayersInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_PlayersInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_players(inputs)
	if (locale === "ja") return ja_tab_players(inputs)
	if (locale === "zh") return zh_tab_players(inputs)
	if (locale === "es") return es_tab_players(inputs)
	if (locale === "pt") return pt_tab_players(inputs)
	if (locale === "id") return id_tab_players(inputs)
	if (locale === "fr") return fr_tab_players(inputs)
	if (locale === "tl") return tl_tab_players(inputs)
	if (locale === "vi") return vi_tab_players(inputs)
	if (locale === "ko") return ko_tab_players(inputs)
	if (locale === "de") return de_tab_players(inputs)
	if (locale === "ru") return ru_tab_players(inputs)
	if (locale === "tr") return tr_tab_players(inputs)
	if (locale === "it") return it_tab_players(inputs)
	if (locale === "pl") return pl_tab_players(inputs)
	if (locale === "uk") return uk_tab_players(inputs)
	if (locale === "hi") return hi_tab_players(inputs)
	if (locale === "ar") return ar_tab_players(inputs)
	if (locale === "ms") return ms_tab_players(inputs)
	if (locale === "bn") return bn_tab_players(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_players(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_players(inputs)
	if (locale === "ur") return ur_tab_players(inputs)
	if (locale === "fa") return fa_tab_players(inputs)
	if (locale === "sw") return sw_tab_players(inputs)
	if (locale === "nl") return nl_tab_players(inputs)
	return en_tab_players(inputs)
});